export const navCategories = [
  { id: 'he liao', name: '黑料今日', slug: 'heiliao-jinri', icon: 'ri-fire-line' },
  { id: 'wanghong-tafang', name: '网红塌房', slug: 'wanghong-tafang', icon: 'ri-alert-line' },
  { id: 'mingxing', name: '明星私聊', slug: 'mingxing-siliao', icon: 'ri-chat-smile-2-line' },
  { id: 'shipin', name: '黑料视频', slug: 'heiliao-shipin', icon: 'ri-vidicon-line' },
  { id: 'zongyi', name: '综艺黑幕', slug: 'zongyi-heimu', icon: 'ri-tv-line' },
];

export const heroArticles = [
  {
    id: 'article-1',
    title: '顶流男星深夜私会女粉丝？录音曝光后全网哗然',
    slug: 'dingliu-nanxing-si-hui',
    category: '明星私聊',
    image: 'https://readdy.ai/api/search-image?query=Dark%20moody%20atmosphere%20with%20silhouette%20of%20a%20person%20behind%20frosted%20glass%2C%20mysterious%20lighting%2C%20film%20noir%20style%2C%20dramatic%20shadows%2C%20minimalist%20composition%2C%20dark%20background%20with%20soft%20warm%20light%20leak%2C%20editorial%20photography%2C%20high%20contrast&width=800&height=1000&seq=hero-article-1&orientation=portrait',
    excerpt: '近日有网友爆料某顶流男星深夜与女粉丝私会，并提供了长达三小时的录音证据...',
    date: '2026-07-07',
    hot: true,
  },
  {
    id: 'article-2',
    title: '百万粉网红直播间翻车，前男友突然闯入揭露造假黑幕',
    slug: 'baiwan-wanghong-zhibo-fanche',
    category: '网红塌房',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20scene%20of%20a%20studio%20with%20bright%20ring%20light%20and%20camera%20equipment%2C%20chaotic%20atmosphere%2C%20dark%20warm%20tones%2C%20editorial%20photography%20style%2C%20high%20contrast%20lighting%2C%20minimalist%20composition%2C%20tense%20mood&width=800&height=1000&seq=hero-article-2&orientation=portrait',
    excerpt: '昨晚某百万粉丝网红正在直播带货时，前男友突然闯入直播间...',
    date: '2026-07-06',
    hot: true,
  },
  {
    id: 'article-3',
    title: '知名女星与经纪人聊天记录曝光，涉及多位圈内大佬',
    slug: 'nvxing-jingjiren-liaotian',
    category: '黑料今日',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20smartphone%20screen%20glowing%20in%20the%20dark%2C%20chat%20messages%20visible%20on%20screen%2C%20dramatic%20low%20key%20lighting%2C%20film%20noir%20aesthetic%2C%20dark%20background%2C%20editorial%20photography%2C%20moody%20atmosphere&width=800&height=1000&seq=hero-article-3&orientation=portrait',
    excerpt: '近日一份据称是某知名女星与经纪人的私密聊天记录被曝光...',
    date: '2026-07-06',
    hot: false,
  },
];

export const heiliaoVideos = [
  {
    id: 'video-1',
    title: '独家：某选秀冠军后台发飙全过程',
    subtitle: '黑料实拍 · 12分钟',
    image: 'https://readdy.ai/api/search-image?query=Backstage%20area%20of%20a%20TV%20studio%20with%20dramatic%20lighting%2C%20empty%20corridor%2C%20mysterious%20atmosphere%2C%20warm%20tungsten%20light%2C%20cinematic%20composition%2C%20film%20grain%20texture%2C%20minimalist%20style&width=640&height=480&seq=video-1&orientation=landscape',
    slug: 'xuanxiu-guanjun-houtai',
    views: '128万',
  },
  {
    id: 'video-2',
    title: '网红情侣分手内幕：三年聊天记录全公开',
    subtitle: '聊天实锤 · 25分钟',
    image: 'https://readdy.ai/api/search-image?query=Two%20smartphones%20on%20a%20dark%20wooden%20table%2C%20screen%20showing%20chat%20interface%2C%20dim%20ambient%20lighting%2C%20moody%20atmosphere%2C%20cinematic%20composition%2C%20film%20noir%20style%2C%20minimalist%20aesthetic&width=640&height=480&seq=video-2&orientation=landscape',
    slug: 'wanghong-qinglv-fenshou',
    views: '96万',
  },
  {
    id: 'video-3',
    title: '综艺录制现场工作人员实名举报',
    subtitle: '实名爆料 · 18分钟',
    image: 'https://readdy.ai/api/search-image?query=TV%20production%20set%20with%20professional%20cameras%20and%20lights%2C%20empty%20stage%2C%20dramatic%20cinematic%20lighting%2C%20dark%20moody%20atmosphere%2C%20film%20grain%2C%20editorial%20photography%20style&width=640&height=480&seq=video-3&orientation=landscape',
    slug: 'zongyi-luzhi-jubao',
    views: '205万',
  },
  {
    id: 'video-4',
    title: '某顶流团队内部录音：合同黑幕全解析',
    subtitle: '内部爆料 · 32分钟',
    image: 'https://readdy.ai/api/search-image?query=Old%20fashioned%20audio%20recorder%20on%20a%20dark%20desk%2C%20dim%20warm%20lighting%2C%20mysterious%20vintage%20atmosphere%2C%20film%20noir%20aesthetic%2C%20cinematic%20composition%2C%20minimalist%20style&width=640&height=480&seq=video-4&orientation=landscape',
    slug: 'dingliu-hetong-heimu',
    views: '167万',
  },
];

export const featuredArticles = [
  {
    id: 'featured-1',
    title: '娱乐圈年度最大瓜：某制作人被多人联名举报潜规则',
    slug: 'yulequan-niandu-zuida-gua',
    category: '黑料今日',
    image: 'https://readdy.ai/api/search-image?query=Empty%20theater%20stage%20with%20single%20spotlight%2C%20dark%20dramatic%20atmosphere%2C%20red%20velvet%20curtains%2C%20mysterious%20mood%2C%20cinematic%20composition%2C%20film%20noir%20style%2C%20minimalist%20aesthetic&width=900&height=600&seq=featured-1&orientation=landscape',
    excerpt: '多位圈内人士联名举报某知名制作人利用职务之便进行潜规则操作...',
    date: '2026-07-07',
    tags: ['潜规则', '联名举报', '制作人'],
  },
  {
    id: 'featured-2',
    title: '某女团成员私下吐槽公司压榨，录音文件流出',
    slug: 'nvtuan-chengyuan-tucao',
    category: '网红塌房',
    image: 'https://readdy.ai/api/search-image?query=Kpop%20style%20dance%20practice%20room%20with%20mirrors%2C%20dim%20lighting%2C%20empty%20and%20lonely%20atmosphere%2C%20minimalist%20composition%2C%20melancholic%20mood%2C%20editorial%20photography%2C%20cool%20tones&width=900&height=600&seq=featured-2&orientation=landscape',
    excerpt: '一段据称是某女团成员的私下录音被曝光，录音中该成员详细讲述了公司的种种不公...',
    date: '2026-07-06',
    tags: ['女团', '录音曝光', '公司压榨'],
  },
  {
    id: 'featured-3',
    title: '知名导演私生活混乱？多位女演员实名爆料',
    slug: 'zhiming-daoyan-sishenghuo',
    category: '明星私聊',
    image: 'https://readdy.ai/api/search-image?query=Film%20director%20chair%20on%20empty%20movie%20set%2C%20dark%20dramatic%20lighting%2C%20cinematic%20atmosphere%2C%20film%20noir%20style%2C%20moody%20composition%2C%20minimalist%20aesthetic%2C%20high%20contrast&width=900&height=600&seq=featured-3&orientation=landscape',
    excerpt: '近日多名女演员站出来实名举报某知名导演长期利用职务之便...',
    date: '2026-07-05',
    tags: ['导演', '实名举报', '女演员'],
  },
];

export const dailyArticles = [
  {
    id: 'daily-1',
    title: '选秀节目内定冠军？知情人曝光投票数据造假内幕',
    slug: 'xuanxiu-neiding-guanjun',
    category: '综艺黑幕',
    image: 'https://readdy.ai/api/search-image?query=Talent%20show%20voting%20screen%20with%20numbers%20and%20graphs%2C%20dark%20moody%20atmosphere%2C%20dramatic%20lighting%2C%20editorial%20photography%2C%20minimalist%20composition%2C%20business%20investigation%20theme&width=700&height=500&seq=daily-1&orientation=landscape',
    excerpt: '知情人士曝光某大型选秀节目的投票数据存在严重造假，冠军早已内定...',
    date: '2026-07-07',
    views: '89万',
    hot: true,
  },
  {
    id: 'daily-2',
    title: '知名夫妻档网红被曝早已离婚，合伙割韭菜真相曝光',
    slug: 'fuqidang-wanghong-lihun',
    category: '网红塌房',
    image: 'https://readdy.ai/api/search-image?query=Split%20apart%20wedding%20rings%20on%20dark%20surface%2C%20dramatic%20lighting%2C%20emotional%20atmosphere%2C%20minimalist%20composition%2C%20film%20noir%20style%2C%20editorial%20photography&width=700&height=500&seq=daily-2&orientation=landscape',
    excerpt: '粉丝眼中恩爱的夫妻档网红，实际上早已离婚却仍在合体直播带货...',
    date: '2026-07-07',
    views: '156万',
    hot: true,
  },
  {
    id: 'daily-3',
    title: '某当红小生与多位女星暧昧聊天记录流出',
    slug: 'danghong-xiaosheng-aimu',
    category: '明星私聊',
    image: 'https://readdy.ai/api/search-image?query=Smartphone%20displaying%20messaging%20app%20on%20dark%20bed%20sheets%2C%20intimate%20moody%20lighting%2C%20film%20noir%20aesthetic%2C%20editorial%20photography%2C%20minimalist%20composition&width=700&height=500&seq=daily-3&orientation=landscape',
    excerpt: '近日一份涉及某当红小生与多位女星的暧昧聊天记录在网络上疯传...',
    date: '2026-07-06',
    views: '312万',
    hot: false,
  },
  {
    id: 'daily-4',
    title: '综艺节目剧本泄露：嘉宾人设全是演出来的？',
    slug: 'zongyi-juben-xielou',
    category: '综艺黑幕',
    image: 'https://readdy.ai/api/search-image?query=Script%20papers%20scattered%20on%20a%20dark%20table%20with%20dim%20spotlight%2C%20mysterious%20atmosphere%2C%20cinematic%20composition%2C%20film%20noir%20style%2C%20minimalist%20aesthetic&width=700&height=500&seq=daily-4&orientation=landscape',
    excerpt: '某热门综艺节目内部剧本被曝光，嘉宾们的人设、冲突甚至是感情线都是提前设计好的...',
    date: '2026-07-06',
    views: '78万',
    hot: false,
  },
  {
    id: 'daily-5',
    title: '网红圈"假名媛"产业链曝光：租豪车豪宅骗粉丝',
    slug: 'jia-mingyuan-chanyelian',
    category: '黑料今日',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20car%20keys%20and%20designer%20bags%20on%20dark%20surface%2C%20mysterious%20moody%20lighting%2C%20editorial%20photography%2C%20minimalist%20composition%2C%20film%20noir%20aesthetic&width=700&height=500&seq=daily-5&orientation=landscape',
    excerpt: '调查发现，许多网红通过租赁豪车、豪宅和高仿奢侈品来营造"名媛"人设...',
    date: '2026-07-05',
    views: '234万',
    hot: false,
  },
  {
    id: 'daily-6',
    title: '知名经纪人被曝克扣艺人收入，涉及金额超千万',
    slug: 'jingjiren-kekou-shouru',
    category: '黑料今日',
    image: 'https://readdy.ai/api/search-image?query=Financial%20documents%20and%20calculator%20on%20dark%20desk%2C%20dramatic%20lighting%2C%20investigation%20theme%2C%20editorial%20photography%2C%20minimalist%20composition%2C%20dark%20atmosphere&width=700&height=500&seq=daily-6&orientation=landscape',
    excerpt: '某知名经纪人被旗下多名艺人联名起诉，指控其长期克扣艺人演出收入...',
    date: '2026-07-05',
    views: '189万',
    hot: false,
  },
];

export const hotComments = [
  {
    id: 'comment-1',
    user: '吃瓜一线',
    avatar: 'https://readdy.ai/api/search-image?query=Anonymous%20user%20avatar%20silhouette%2C%20dark%20minimalist%20style%2C%20simple%20profile%2C%20neutral%20gray%20background&width=80&height=80&seq=avatar-1&orientation=squarish',
    content: '这个圈子真的太乱了，表面光鲜亮丽，背地里不知道有多少见不得人的勾当。这些爆料只是冰山一角，真正的大瓜还没出来呢。',
    time: '2小时前',
    floor: '#128楼',
  },
  {
    id: 'comment-2',
    user: '娱乐圈观察者',
    avatar: 'https://readdy.ai/api/search-image?query=Anonymous%20user%20avatar%20silhouette%2C%20dark%20minimalist%20style%2C%20simple%20profile%2C%20neutral%20gray%20background&width=80&height=80&seq=avatar-2&orientation=squarish',
    content: '我早就说过这个经纪人有问题，终于有人站出来举报了。希望这次能彻查到底，给那些被欺负的艺人一个公道。',
    time: '3小时前',
    floor: '#96楼',
  },
  {
    id: 'comment-3',
    user: '黑料鉴定师',
    avatar: 'https://readdy.ai/api/search-image?query=Anonymous%20user%20avatar%20silhouette%2C%20dark%20minimalist%20style%2C%20simple%20profile%2C%20neutral%20gray%20background&width=80&height=80&seq=avatar-3&orientation=squarish',
    content: '作为一个在这个行业摸爬滚打了十几年的人，我可以负责任地说，这里面的水比你想象的还要深。继续关注，每天都有新瓜。',
    time: '5小时前',
    floor: '#63楼',
  },
];

export const stats = [
  { value: '1280万+', label: '月活跃用户' },
  { value: '5.6万+', label: '累计爆料' },
  { value: '99.7%', label: '用户好评率' },
  { value: '24h', label: '更新频率' },
];